import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const login = async (email, password, totp_code = null, rememberMe = false) => {
    if (shouldLogApiCalls) {
        console.log('Login attempt:', { email });
    }
    
    return post('/user/token', { email, password, totp_code, rememberMe });
}

export const getUser = async () => {
    if (shouldLogApiCalls) {
        console.log('Get user attempt');
    }
    
    return get('/user');
}

export const updateUser = async (user) => {
    if (shouldLogApiCalls) {
        console.log('Update user attempt');
    }
    
    return put('/user', user);
}

export const logout = async () => {
    if (shouldLogApiCalls) {
        console.log('Logout attempt');
    }
    
    return del('/user/token');
}

export const getUserRole = async () => {
    if (shouldLogApiCalls) {
        console.log('Get user role attempt');
    }
    
    return get('/user/role');
}

export const getMFASetup = async () => {
    if (shouldLogApiCalls) {
        console.log('Get MFA setup attempt');
    }
    
    return get('/user/mfa');
}

export const setMFA = async (totp_secret, totp_code) => {
    if (shouldLogApiCalls) {
        console.log('Set MFA attempt');
    }
    
    return post('/user/mfa', { totp_secret, totp_code });
}